/**
 * 프로젝트 ID와 CCTV 템플릿 매핑
 * 각 프로젝트가 어떤 CCTV 템플릿을 사용하는지 정의
 */
export const projectTemplateMapping: Record<string, string> = {
  // 반포 프로젝트
  '290': 'banpo',
};

/**
 * 프로젝트 ID로 템플릿 이름 조회
 * 임시로 모든 프로젝트에서 banpo 템플릿 사용 (서버 개발 전까지)
 */
export function getTemplateNameByProjectId(projectId: string): string | null {
  // 임시: 모든 프로젝트에서 banpo 템플릿 사용
  console.log('임시 처리: 모든 프로젝트에서 banpo 템플릿 사용');
  return 'banpo';

  // 원래 코드 (서버 개발 후 주석 해제)
  // return projectTemplateMapping[projectId] || null;
}
